import { service, BASE_API } from '@/utils/request'

export default {
  // 获取pdf数据
  getHospitalPdf: params => {
    return service({
      url: '/cloud/uac/v1/commons/learnReport',
      method: 'get',
      params
    })
  },
  // 获取医院列表
  getHospitalList: params => {
    return service({
      url: '/cloud/uac/v1/hospital/manage/pages',
      method: 'get',
      params
    })
  },
  // 删除医院
  delHospital: data => {
    return service({
      url: '/cloud/uac/v1/hospital/manage/delete',
      method: 'post',
      data
    })
  },
  // 获取学习报告
  getLearnReport: params => {
    return service({
      url: '/cloud/uac/v1/hospital/manage/learnReport',
      method: 'get',
      params
    })
  },
  // 添加医院
  saveHospital: data => {
    return service({
      url: '/cloud/uac/v1/hospital/manage/save',
      method: 'post',
      data
    })
  },
  // 医院详情
  getHospitalDetail: params => {
    return service({
      url: '/cloud/uac/v1/hospital/manage/detail',
      method: 'get',
      params
    })
  },
  // 医生列表
  getUserList: params => {
    return service({
      url: '/cloud/uac/v1/hospital/manage/userPages',
      method: 'get',
      params
    })
  },
  // 删除医生
  delUser: data => {
    return service({
      url: '/cloud/uac/v1/hospital/manage/deleteUser?' + data,
      method: 'post',
      data
    })
  },
  // 医院列表-导出
  exportExcel(params) {
    return service({
      url: '/cloud/uac/v1/hospital/manage/exportExcel',
      method: 'get',
      params,
      responseType: 'blob'
    })
  },
  excelUploadUser: BASE_API + '/cloud/uac/v1/hospital/manage/importExcel',
  downloadUrl: 'https://file.ibabygroup.cn/Mobxls/commons/xmdd8Vdy2Vt8HPTVbzWzvHRMtjg3dh9F.xls'
}



// WEBPACK FOOTER //
// ./src/api/operateManage/hospitalUserMange.js